module.exports = __webpack_public_path__ + "static/media/android_dots_icon.128f609a.svg";